export default __webpack_public_path__ + "static/media/O-063.b49d17ab.png";